import { BuildingStorefrontIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import Type from "./Type";
import OfficeAppliancesBrand from "./Brand";

export const OfficeAppliancesTabs = [
  {
    to: ROUTE_PATHS.Utilities_OfficeAppliancesConfiguration_Type_Index,
    icon: <BuildingStorefrontIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Type",
    component: Type,
    permission: PERMISSIONS.permission_utilities_officeappliances_type_view,
  },
  {
    to: ROUTE_PATHS.Utilities_OfficeAppliances_Brand_Index,
    icon: <BuildingStorefrontIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Brand",
    component: OfficeAppliancesBrand,
    permission: PERMISSIONS.permission_officeappliancebrand_view,
  },
];
